import { render, staticRenderFns } from "./dailyJournalItems.vue?vue&type=template&id=6e8104a5&"
import script from "./dailyJournalItems.vue?vue&type=script&lang=js&"
export * from "./dailyJournalItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports